import * as Yup from "yup";

export const ContactSchema = Yup.object().shape({
  name: Yup.string().required("Name  is required"),
  phoneNo: Yup.string()
    .required(" Phone No required")
    .min(10, "minimum 10 digits")
    .max(10, "maximum 10 digits")
    .matches(/^[6-9]\d{9}$/, "Phone no must start 6 to 9"),
  EmailId: Yup.string()
    .required(" Email Id is  required ")
    .email("Not a proper email")
    .matches(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/, "Enter proper Email"),
  Address: Yup.string()
    .required("Address is required")
    .matches(
      /^[a-zA-Z0-9\s\\/-]+$/,
      "Only alphanumeric characters, spaces, /, and - are allowed."
    ),
  Message: Yup.string().required("Message is required"),
});

export const ContactValue = {
  name: "",
  phoneNo: "",
  EmailId: "",
  Address: "",
  Message: "",
};
